/* @ds-bundle: {"format":4,"namespace":"SemvetaDesignSystem_5f8165","components":[{"name":"PlanCard","sourcePath":"components/commerce/PlanCard.jsx"},{"name":"PriceBlock","sourcePath":"components/commerce/PriceBlock.jsx"},{"name":"PurchaseCard","sourcePath":"components/commerce/PurchaseCard.jsx"},{"name":"PurchaseOption","sourcePath":"components/commerce/PurchaseOption.jsx"},{"name":"AccordionItem","sourcePath":"components/content/Accordion.jsx"},{"name":"Accordion","sourcePath":"components/content/Accordion.jsx"},{"name":"BenefitCard","sourcePath":"components/content/BenefitCard.jsx"},{"name":"Callout","sourcePath":"components/content/Callout.jsx"},{"name":"Card","sourcePath":"components/content/Card.jsx"},{"name":"ComparisonBar","sourcePath":"components/content/ComparisonBar.jsx"},{"name":"IconCard","sourcePath":"components/content/IconCard.jsx"},{"name":"ReviewCard","sourcePath":"components/content/ReviewCard.jsx"},{"name":"Badge","sourcePath":"components/core/Badge.jsx"},{"name":"Button","sourcePath":"components/core/Button.jsx"},{"name":"Eyebrow","sourcePath":"components/core/Eyebrow.jsx"},{"name":"SectionHeading","sourcePath":"components/core/SectionHeading.jsx"},{"name":"StarRating","sourcePath":"components/core/StarRating.jsx"},{"name":"Tick","sourcePath":"components/core/Tick.jsx"},{"name":"Icon","sourcePath":"components/icon/Icon.jsx"},{"name":"BagIcon","sourcePath":"components/icon/Icon.jsx"},{"name":"Container","sourcePath":"components/layout/Container.jsx"},{"name":"Section","sourcePath":"components/layout/Section.jsx"}],"sourceHashes":{"components/commerce/PlanCard.jsx":"46c71a92f580","components/commerce/PriceBlock.jsx":"2de78d51d7ae","components/commerce/PurchaseCard.jsx":"84c006d0c8da","components/commerce/PurchaseOption.jsx":"e640304251b3","components/content/Accordion.jsx":"813bf3940edc","components/content/BenefitCard.jsx":"1aee29d92183","components/content/Callout.jsx":"72f0cbbd7f49","components/content/Card.jsx":"c659a4f02bf3","components/content/ComparisonBar.jsx":"e55e645025fd","components/content/IconCard.jsx":"a5e6381789c8","components/content/ReviewCard.jsx":"381f6b25ab62","components/core/Badge.jsx":"ab6e586a48b8","components/core/Button.jsx":"9132933e1e72","components/core/Eyebrow.jsx":"3de75c20b630","components/core/SectionHeading.jsx":"0c0eae5e1089","components/core/StarRating.jsx":"a131a6ed4103","components/core/Tick.jsx":"5f041bff5c59","components/icon/Icon.jsx":"c69321bf83d7","components/layout/Container.jsx":"976bb6a96f21","components/layout/Section.jsx":"2e1248dfbd9f","ui_kits/website/MarketingSections.jsx":"a9064d5a1256","ui_kits/website/MobileProduct.jsx":"4e6ea748683d","ui_kits/website/ProductTop.jsx":"73e06e7f76e4","ui_kits/website/SiteFooter.jsx":"352d78cc813f","ui_kits/website/SiteHeader.jsx":"dbd9166e597a"},"inlinedExternals":[],"unexposedExports":[]} */

(() => {

const __ds_ns = (window.SemvetaDesignSystem_5f8165 = window.SemvetaDesignSystem_5f8165 || {});

const __ds_scope = {};

(__ds_ns.__errors = __ds_ns.__errors || []);

// components/commerce/PlanCard.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PlanCard({
  selected = false,
  onSelect,
  banner,
  title,
  price,
  was,
  details,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    onClick: onSelect,
    style: {
      border: "0.5px solid var(--teal-900)",
      borderRadius: 6,
      overflow: "hidden",
      marginBottom: 13,
      cursor: "pointer",
      background: selected ? "#ffffff" : "#f9f4ed",
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-light)",
      color: "#000",
      ...style
    }
  }, rest), banner, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 16,
      padding: "13px 16px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: "var(--weight-regular)",
      fontSize: 14.5,
      whiteSpace: "nowrap"
    }
  }, title), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 8
    }
  }, was ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13.5,
      fontWeight: "var(--weight-light)",
      color: "#7f7f7f",
      textDecoration: "line-through"
    }
  }, was) : null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13.5,
      fontWeight: "var(--weight-regular)"
    }
  }, price))), selected && details ? /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "0 16px 14px",
      fontSize: "var(--size-caption)",
      fontWeight: "var(--weight-light)",
      lineHeight: 1.6
    }
  }, details) : null);
}
Object.assign(__ds_scope, { PlanCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/PlanCard.jsx", error: String((e && e.message) || e) }); }

// components/commerce/PriceBlock.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PriceBlock({
  price,
  was,
  unit,
  align = "flex-end",
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: align,
      gap: 8,
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-regular)",
      fontSize: "var(--size-price)",
      lineHeight: 1,
      color: "var(--ink-880)"
    }
  }, price, unit ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: "var(--weight-light)"
    }
  }, " ", unit) : null), was ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-light)",
      fontSize: 11,
      lineHeight: 1,
      textDecoration: "line-through",
      color: "var(--ink-420)"
    }
  }, was) : null);
}
Object.assign(__ds_scope, { PriceBlock });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/PriceBlock.jsx", error: String((e && e.message) || e) }); }

// components/commerce/PurchaseOption.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PurchaseOption({
  selected = false,
  onSelect,
  title,
  subtitle,
  badge,
  price,
  children,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    onClick: onSelect,
    style: {
      display: "grid",
      gridTemplateColumns: "26px 1fr auto",
      alignItems: "center",
      gap: 12,
      width: "100%",
      minHeight: 67,
      padding: "15px 17px",
      boxSizing: "border-box",
      border: "1.5px solid " + (selected ? "var(--forest-500)" : "var(--sand-380)"),
      borderRadius: "var(--radius-option)",
      background: selected ? "var(--mint-100)" : "var(--cream-25)",
      cursor: "pointer",
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      width: 20,
      height: 20,
      boxSizing: "border-box",
      border: "2px solid " + (selected ? "var(--forest-500)" : "var(--sand-400)"),
      borderRadius: "var(--radius-full)"
    }
  }, selected ? /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      top: "50%",
      left: "50%",
      width: 10,
      height: 10,
      borderRadius: "var(--radius-full)",
      background: "var(--forest-500)",
      transform: "translate(-50%,-50%)"
    }
  }) : null), /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "block",
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-regular)",
      fontSize: 15,
      lineHeight: 1.4,
      color: "var(--ink-880)",
      whiteSpace: "nowrap"
    }
  }, title), badge ? /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      margin: "7px 0"
    }
  }, badge) : null, subtitle ? /*#__PURE__*/React.createElement("span", {
    style: {
      display: "block",
      marginTop: 5,
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-light)",
      fontSize: "var(--size-caption)",
      lineHeight: 1.5,
      color: "#7d8d83"
    }
  }, subtitle) : null), /*#__PURE__*/React.createElement("span", null, price), children ? /*#__PURE__*/React.createElement("span", {
    style: {
      gridColumn: "1 / -1"
    }
  }, children) : null);
}
Object.assign(__ds_scope, { PurchaseOption });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/PurchaseOption.jsx", error: String((e && e.message) || e) }); }

// components/content/BenefitCard.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function BenefitCard({
  icon,
  alt = "",
  heading,
  copy,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      minHeight: 255,
      padding: "22px 19px",
      boxSizing: "border-box",
      border: "1px solid var(--sand-360)",
      borderRadius: 18,
      background: "var(--cream-30)",
      ...style
    }
  }, rest), icon ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      width: 49,
      height: 49,
      marginBottom: 20
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: icon,
    alt: alt,
    style: {
      display: "block",
      width: 49,
      height: 49,
      objectFit: "contain"
    }
  })) : null, /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: "0 0 8px",
      fontFamily: "var(--font-display)",
      fontWeight: "var(--weight-regular)",
      fontSize: "var(--size-subhead-xs)",
      lineHeight: 1.25,
      letterSpacing: "var(--ls-subhead)",
      color: "var(--ink-880)"
    }
  }, heading), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-light)",
      fontSize: "var(--size-body-sm)",
      lineHeight: "var(--lh-body)",
      color: "var(--ink-560)"
    }
  }, copy));
}
Object.assign(__ds_scope, { BenefitCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/content/BenefitCard.jsx", error: String((e && e.message) || e) }); }

// components/content/Callout.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Callout({
  children,
  tone = "cream",
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 11,
      padding: "10px 18px 10px 10px",
      boxSizing: "border-box",
      borderRadius: "var(--radius-callout)",
      background: tone === "dark" ? "var(--surface-dark-card)" : "var(--cream-40)",
      fontFamily: "var(--font-display)",
      fontWeight: "var(--weight-regular)",
      fontSize: 15,
      lineHeight: "var(--lh-subhead)",
      letterSpacing: "var(--ls-subhead)",
      color: tone === "dark" ? "var(--ink-on-dark-heading)" : "var(--ink-860)",
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Callout });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/content/Callout.jsx", error: String((e && e.message) || e) }); }

// components/content/Card.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TONE = {
  cream: {
    background: "var(--cream-50)",
    border: "1px solid var(--sand-360)",
    color: "var(--ink-880)"
  },
  sand: {
    background: "var(--cream-40)",
    border: "1px solid var(--sand-350)",
    color: "var(--ink-860)"
  },
  linen: {
    background: "var(--linen-50)",
    border: "none",
    color: "var(--ink-840)"
  },
  raised: {
    background: "var(--cream-25)",
    border: "none",
    color: "var(--ink-880)"
  },
  review: {
    background: "var(--sand-100)",
    border: "none",
    color: "var(--ink-880)"
  },
  dark: {
    background: "var(--surface-dark-card)",
    border: "1px solid var(--border-dark-card)",
    color: "var(--ink-on-dark-heading)"
  }
};
function Card({
  children,
  tone = "cream",
  radius,
  padding,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      width: "100%",
      boxSizing: "border-box",
      borderRadius: radius || "var(--radius-card)",
      padding: padding || "34px 34px 30px",
      boxShadow: "var(--shadow-none)",
      ...(TONE[tone] || TONE.cream),
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Card });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/content/Card.jsx", error: String((e && e.message) || e) }); }

// components/content/ComparisonBar.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ComparisonBar({
  label,
  value,
  percent = 100,
  tone = "chaski",
  style,
  ...rest
}) {
  const green = tone === "chaski";
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      marginBottom: 26,
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 16,
      marginBottom: 14
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: "var(--weight-regular)",
      fontSize: "var(--size-subhead-sm)",
      lineHeight: "var(--lh-subhead)",
      letterSpacing: "var(--ls-subhead)",
      color: green ? "var(--ink-860)" : "var(--ink-520)"
    }
  }, label), /*#__PURE__*/React.createElement("span", {
    style: {
      flex: "0 0 auto",
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-light)",
      fontSize: "var(--size-figure)",
      lineHeight: 1,
      color: green ? "var(--forest-700)" : "var(--gold-500)"
    }
  }, value)), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      height: 18,
      overflow: "hidden",
      borderRadius: "var(--radius-pill)",
      background: "var(--sand-420)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: percent + "%",
      height: "100%",
      borderRadius: "var(--radius-pill)",
      background: green ? "var(--forest-500)" : "var(--bronze-300)"
    }
  })));
}
Object.assign(__ds_scope, { ComparisonBar });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/content/ComparisonBar.jsx", error: String((e && e.message) || e) }); }

// components/content/IconCard.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function IconCard({
  icon,
  alt = "",
  heading,
  copy,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      flex: "1 1 0",
      minWidth: 0,
      boxSizing: "border-box",
      padding: "44px 30px 40px",
      borderRadius: "var(--radius-card)",
      background: "var(--linen-50)",
      textAlign: "center",
      ...style
    }
  }, rest), icon ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 78,
      height: 78,
      margin: "0 auto 24px",
      overflow: "hidden",
      borderRadius: "var(--radius-full)",
      background: "transparent"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: icon,
    alt: alt,
    style: {
      display: "block",
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }
  })) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 10,
      fontFamily: "var(--font-display)",
      fontWeight: "var(--weight-regular)",
      fontSize: "var(--size-subhead)",
      lineHeight: "var(--lh-subhead)",
      letterSpacing: "var(--ls-subhead)",
      color: "var(--ink-840)"
    }
  }, heading), /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 300,
      margin: "0 auto",
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-light)",
      fontSize: "var(--size-body)",
      lineHeight: "var(--lh-body)",
      color: "var(--ink-640)"
    }
  }, copy));
}
Object.assign(__ds_scope, { IconCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/content/IconCard.jsx", error: String((e && e.message) || e) }); }

// components/core/Badge.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TONE = {
  forest: "var(--forest-500)",
  taupe: "var(--taupe-500)",
  aubergine: "var(--aubergine-500)"
};
function Badge({
  children,
  tone = "forest",
  variant = "pill",
  style,
  ...rest
}) {
  const banner = variant === "banner";
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      display: banner ? "block" : "inline-flex",
      alignItems: "center",
      gap: 4,
      padding: banner ? "5px 13px" : "4px 11px",
      boxSizing: "border-box",
      borderRadius: banner ? 0 : "var(--radius-badge)",
      background: TONE[tone] || TONE.forest,
      color: "#fff",
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-regular)",
      fontSize: banner ? 13 : 11,
      lineHeight: 1.2,
      textAlign: banner ? "center" : undefined,
      whiteSpace: "nowrap",
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Badge });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Badge.jsx", error: String((e && e.message) || e) }); }

// components/core/Button.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const FILL = {
  primary: {
    background: "var(--forest-500)",
    color: "var(--action-primary-label)",
    border: "none"
  },
  primaryHover: {
    background: "var(--forest-600)"
  },
  secondary: {
    background: "var(--ink-880)",
    color: "var(--cream-100)",
    border: "none"
  },
  secondaryHover: {
    background: "var(--cocoa-900)"
  },
  tertiary: {
    background: "transparent",
    color: "var(--ink-880)",
    border: "1.5px solid var(--ink-880)"
  },
  tertiaryHover: {
    background: "rgba(44,29,19,.06)"
  }
};
const SIZE = {
  md: {
    minHeight: 58,
    padding: "15px 32px",
    fontSize: "var(--size-button)",
    borderRadius: "var(--radius-button)"
  },
  lg: {
    minHeight: 58,
    padding: "15px 40px",
    fontSize: "var(--size-button-lg)",
    borderRadius: "var(--radius-button)"
  },
  block: {
    minHeight: 58,
    padding: 14,
    fontSize: "var(--size-button-lg)",
    borderRadius: "var(--radius-button-sm)"
  }
};
function Button({
  children,
  variant = "primary",
  size = "md",
  fullWidth = false,
  disabled = false,
  as,
  href,
  onClick,
  style,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const Tag = as || (href ? "a" : "button");
  const base = FILL[variant] || FILL.primary;
  const hoverFill = FILL[variant + "Hover"] || {};
  return /*#__PURE__*/React.createElement(Tag, _extends({
    href: href,
    onClick: disabled ? undefined : onClick,
    disabled: Tag === "button" ? disabled : undefined,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      display: fullWidth ? "flex" : "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: fullWidth ? "100%" : undefined,
      boxSizing: "border-box",
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-regular)",
      lineHeight: 1.2,
      textDecoration: "none",
      whiteSpace: "nowrap",
      cursor: disabled ? "default" : "pointer",
      opacity: disabled ? 0.7 : 1,
      transition: "var(--transition-action)",
      ...SIZE[size],
      ...base,
      ...(hover && !disabled ? hoverFill : null),
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Button });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Button.jsx", error: String((e && e.message) || e) }); }

// components/core/Eyebrow.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TONE = {
  cream: "var(--bronze-500)",
  sand: "var(--bronze-400)",
  linen: "var(--bronze-450)",
  cocoa: "var(--bronze-350)"
};
function Eyebrow({
  children,
  tone = "cream",
  size = "md",
  align,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-regular)",
      fontSize: size === "sm" ? "13px" : size === "mobile" ? "var(--size-eyebrow-mobile)" : "var(--size-eyebrow)",
      lineHeight: 1.2,
      letterSpacing: size === "sm" ? "var(--ls-eyebrow-tight)" : "var(--ls-eyebrow)",
      color: TONE[tone] || TONE.cream,
      textAlign: align,
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Eyebrow });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Eyebrow.jsx", error: String((e && e.message) || e) }); }

// components/core/SectionHeading.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  tone = "light",
  ground = "cream",
  size = "md",
  style,
  ...rest
}) {
  const dark = tone === "dark";
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      textAlign: align,
      ...style
    }
  }, rest), eyebrow ? /*#__PURE__*/React.createElement(__ds_scope.Eyebrow, {
    tone: dark ? "cocoa" : ground,
    style: {
      marginBottom: align === "center" ? 16 : 20
    }
  }, eyebrow) : null, /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: description ? "0 0 20px" : "0 0 24px",
      fontFamily: "var(--font-display)",
      fontWeight: "var(--weight-regular)",
      fontSize: size === "lg" ? "var(--size-display-lg)" : size === "sm" ? "var(--size-display-sm)" : "var(--size-display)",
      lineHeight: size === "lg" ? 1 : "var(--lh-display)",
      letterSpacing: size === "lg" ? "var(--ls-display-lg)" : "var(--ls-display)",
      color: dark ? "var(--ink-on-dark)" : "var(--text-heading)"
    }
  }, title), description ? /*#__PURE__*/React.createElement("p", {
    style: {
      maxWidth: 560,
      margin: align === "center" ? "0 auto" : 0,
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-light)",
      fontSize: "var(--size-lead)",
      lineHeight: "var(--lh-lead)",
      color: dark ? "var(--ink-on-dark-body)" : "var(--text-body)"
    }
  }, description) : null);
}
Object.assign(__ds_scope, { SectionHeading });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/SectionHeading.jsx", error: String((e && e.message) || e) }); }

// components/core/StarRating.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function StarRating({
  count = 5,
  tone = "green",
  size,
  label,
  style,
  ...rest
}) {
  const gold = tone === "gold";
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      display: "flex",
      alignItems: "center",
      gap: gold ? 10 : 14,
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("span", {
    style: {
      color: gold ? "var(--star-gold)" : "var(--forest-450)",
      fontSize: size || (gold ? 18 : 22),
      lineHeight: 1,
      letterSpacing: gold ? "-1.5px" : "3px"
    }
  }, "★".repeat(count)), label ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-light)",
      fontSize: gold ? 14 : 14.5,
      lineHeight: 1.2,
      color: gold ? "var(--teal-900)" : "var(--ink-480)"
    }
  }, label) : null);
}
Object.assign(__ds_scope, { StarRating });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/StarRating.jsx", error: String((e && e.message) || e) }); }

// components/content/ReviewCard.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ReviewCard({
  quote,
  name,
  tag = "Verified buyer",
  stars = 5,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      flex: "1 1 0",
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
      padding: "34px 32px 32px",
      borderRadius: "var(--radius-card)",
      background: "var(--sand-100)",
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement(__ds_scope.StarRating, {
    count: stars,
    style: {
      marginBottom: 22
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "0 0 28px",
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-light)",
      fontSize: "var(--size-lead)",
      lineHeight: "var(--lh-lead)",
      color: "var(--ink-880)"
    }
  }, quote), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "auto"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 3,
      fontFamily: "var(--font-display)",
      fontWeight: "var(--weight-regular)",
      fontSize: "var(--size-subhead-xs)",
      lineHeight: "var(--lh-subhead)",
      letterSpacing: "var(--ls-subhead)",
      color: "var(--ink-880)"
    }
  }, name), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-light)",
      fontSize: 14.5,
      lineHeight: 1.2,
      color: "var(--ink-480)"
    }
  }, tag)));
}
Object.assign(__ds_scope, { ReviewCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/content/ReviewCard.jsx", error: String((e && e.message) || e) }); }

// components/core/Tick.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Tick({
  variant = "glyph",
  size,
  style,
  ...rest
}) {
  if (variant === "disc") {
    const d = size || 36;
    return /*#__PURE__*/React.createElement("span", _extends({
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "0 0 " + d + "px",
        width: d,
        height: d,
        borderRadius: "var(--radius-full)",
        background: "var(--mint-50)",
        color: "var(--forest-500)",
        fontSize: 18,
        lineHeight: 1,
        ...style
      }
    }, rest), "\u2713");
  }
  if (variant === "tile") {
    const d = size || 40;
    return /*#__PURE__*/React.createElement("span", _extends({
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "0 0 " + d + "px",
        width: d,
        height: d,
        borderRadius: "var(--radius-tick)",
        background: "var(--forest-400)",
        color: "#fff",
        fontSize: 17,
        lineHeight: 1,
        ...style
      }
    }, rest), "\u2713");
  }
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      color: "var(--forest-500)",
      fontSize: size || 16,
      lineHeight: 1,
      ...style
    }
  }, rest), "\u2713");
}
Object.assign(__ds_scope, { Tick });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Tick.jsx", error: String((e && e.message) || e) }); }

// components/commerce/PurchaseCard.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PurchaseCard({
  image,
  title,
  subtitle,
  reviewCount,
  children,
  footnote = "30-day money-back guarantee",
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      width: "100%",
      padding: "22px 22px 27px",
      boxSizing: "border-box",
      borderRadius: "var(--radius-card-xl)",
      background: "var(--cream-25)",
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 17,
      marginBottom: 21
    }
  }, image ? /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "0 0 113px",
      width: 113,
      height: 113,
      overflow: "hidden",
      borderRadius: "var(--radius-thumb)",
      background: "var(--sand-150)"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: "",
    style: {
      display: "block",
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }
  })) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: "0 0 6px",
      fontFamily: "var(--font-display)",
      fontWeight: "var(--weight-regular)",
      fontSize: "var(--size-subhead-xs)",
      lineHeight: 1.05,
      letterSpacing: "var(--ls-subhead)",
      color: "var(--ink-880)"
    }
  }, title), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "0 0 12px",
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-light)",
      fontSize: "var(--size-body-sm)",
      lineHeight: 1.4,
      color: "var(--ink-600)"
    }
  }, subtitle), reviewCount ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 9
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 16,
      lineHeight: 1,
      letterSpacing: "1px",
      color: "var(--forest-500)"
    }
  }, "\u2605\u2605\u2605\u2605\u2605"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-light)",
      fontSize: "var(--size-body-sm)",
      lineHeight: 1.2,
      color: "#534a58"
    }
  }, reviewCount)) : null)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 12
    }
  }, children), footnote ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      marginTop: 17,
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-light)",
      fontSize: 13,
      lineHeight: 1.3,
      color: "var(--ink-600)"
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Tick, {
    size: 18
  }), /*#__PURE__*/React.createElement("span", null, footnote)) : null);
}
Object.assign(__ds_scope, { PurchaseCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/PurchaseCard.jsx", error: String((e && e.message) || e) }); }

// components/icon/Icon.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Paths copied verbatim from the live Shopify (Motion) theme and the Chaski FAQ block.
   Nothing here was redrawn. Stroke-only, no fill, on a 64-unit grid unless noted. */
const PATHS = {
  hamburger: {
    box: "0 0 64 64",
    d: "M7 15h51M7 32h43M7 49h51"
  },
  user: {
    box: "0 0 64 64",
    d: "M35 39.84v-2.53c3.3-1.91 6-6.66 6-11.41 0-7.63 0-13.82-9-13.82s-9 6.19-9 13.82c0 4.75 2.7 9.51 6 11.41v2.53c-10.18.85-18 6-18 12.16h42c0-6.19-7.82-11.31-18-12.16z",
    fill: true
  },
  search: {
    box: "0 0 64 64",
    d: "M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58zM54 54L41.94 42"
  },
  close: {
    box: "0 0 64 64",
    d: "M19 17.61l27.12 27.13m0-27.12L19 44.74"
  },
  chevronDownWide: {
    box: "0 0 28 16",
    d: "M1.57 1.59l12.76 12.77L27.1 1.59",
    width: 2
  },
  chevronDown: {
    box: "0 0 24 24",
    d: "M6 9l6 6 6-6",
    width: 2,
    round: true
  }
};
function Icon({
  name = "search",
  size = 24,
  color = "currentColor",
  strokeWidth,
  style,
  ...rest
}) {
  const p = PATHS[name] || PATHS.search;
  if (p.fill) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      viewBox: p.box,
      width: size,
      height: size,
      "aria-hidden": "true",
      style: {
        display: "block",
        ...style
      }
    }, rest), /*#__PURE__*/React.createElement("path", {
      d: p.d,
      fill: color
    }));
  }
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: p.box,
    width: size,
    height: size,
    "aria-hidden": "true",
    style: {
      display: "block",
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: p.d,
    fill: "none",
    stroke: color,
    strokeWidth: strokeWidth || p.width || 1.5,
    strokeLinecap: p.round ? "round" : undefined,
    strokeLinejoin: p.round ? "round" : undefined
  }));
}
function BagIcon({
  size = 24,
  color = "currentColor",
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    width: size,
    height: size,
    "aria-hidden": "true",
    style: {
      display: "block",
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M11.375 17.863h41.25v36.75h-41.25z",
    fill: "none",
    stroke: color,
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25 18c0-7.105 4.35-9 9.75-9s9.75 1.895 9.75 9",
    fill: "none",
    stroke: color,
    strokeWidth: "1.5"
  }));
}
Object.assign(__ds_scope, { Icon, BagIcon });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/icon/Icon.jsx", error: String((e && e.message) || e) }); }

// components/content/Accordion.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function AccordionItem({
  question,
  answer,
  open,
  onToggle,
  tone = "light",
  last
}) {
  const dark = tone === "dark";
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "24px 0",
      borderTop: last ? undefined : undefined
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onToggle,
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 18,
      width: "100%",
      margin: 0,
      padding: 0,
      border: "none",
      background: "transparent",
      cursor: "pointer",
      textAlign: "left",
      fontFamily: "var(--font-display)",
      fontWeight: "var(--weight-regular)",
      fontSize: "var(--size-subhead-xs)",
      lineHeight: 1.25,
      letterSpacing: "var(--ls-subhead)",
      color: dark ? "var(--ink-on-dark-heading)" : "var(--ink-880)"
    }
  }, /*#__PURE__*/React.createElement("span", null, question), /*#__PURE__*/React.createElement(__ds_scope.Icon, {
    name: "chevronDown",
    size: 20,
    strokeWidth: 2,
    color: "var(--indigo-600)",
    style: {
      flex: "0 0 20px",
      transform: open ? "rotate(180deg)" : "none",
      transition: "var(--transition-chevron)"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      maxHeight: open ? 600 : 0,
      overflow: "hidden",
      transition: "var(--transition-accordion)"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "14px 0 0",
      fontFamily: "var(--font-body)",
      fontWeight: "var(--weight-light)",
      fontSize: "var(--size-body-sm)",
      lineHeight: "var(--lh-body)",
      color: dark ? "var(--ink-on-dark-muted)" : "var(--ink-660)"
    }
  }, answer)));
}
function Accordion({
  items = [],
  defaultOpen = 0,
  tone = "light",
  style,
  ...rest
}) {
  const [open, setOpen] = React.useState(defaultOpen);
  const dark = tone === "dark";
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      width: "100%",
      padding: "6px 24px",
      boxSizing: "border-box",
      border: dark ? "1px solid var(--border-dark-card)" : "1px solid var(--sand-360)",
      borderRadius: "var(--radius-card-lg)",
      background: dark ? "var(--surface-dark-card)" : "var(--cream-50)",
      ...style
    }
  }, rest), items.map((it, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    style: i === 0 ? null : {
      borderTop: dark ? "1px solid var(--hairline-light)" : "1px solid var(--hairline-dark)"
    }
  }, /*#__PURE__*/React.createElement(AccordionItem, {
    question: it.question,
    answer: it.answer,
    tone: tone,
    open: open === i,
    onToggle: () => setOpen(open === i ? -1 : i)
  }))));
}
Object.assign(__ds_scope, { AccordionItem, Accordion });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/content/Accordion.jsx", error: String((e && e.message) || e) }); }

// components/layout/Container.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Container({
  children,
  padY,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      position: "relative",
      zIndex: 1,
      width: "100%",
      maxWidth: "var(--container-max)",
      margin: "0 auto",
      padding: (padY || "var(--section-pad-y)") + " var(--container-pad)",
      boxSizing: "border-box",
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Container });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/layout/Container.jsx", error: String((e && e.message) || e) }); }

// components/layout/Section.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const GROUND = {
  cream: {
    background: "var(--cream-100)"
  },
  linen: {
    background: "var(--linen-100)"
  },
  sand: {
    background: "var(--sand-200)"
  },
  wheat: {
    background: "var(--wheat-200)"
  },
  cocoa: {
    background: "var(--cocoa-900)"
  }
};
function Section({
  tone = "cream",
  children,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("section", _extends({
    style: {
      position: "relative",
      width: "100%",
      boxSizing: "border-box",
      fontFamily: "var(--font-body)",
      ...(GROUND[tone] || GROUND.cream),
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Section });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/layout/Section.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/MarketingSections.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const DS = window.SemvetaDesignSystem_5f8165 || {};
const {
  Section,
  Container,
  SectionHeading,
  Eyebrow,
  Button,
  Tick,
  Card,
  Callout,
  ComparisonBar,
  ReviewCard,
  IconCard,
  Accordion
} = DS;
function HeroSection({
  onCta
}) {
  return /*#__PURE__*/React.createElement(Section, {
    tone: "cream",
    "data-screen-label": "Hero"
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      display: "flex",
      alignItems: "flex-start",
      gap: "var(--col-gap)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "1 1 50%",
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(SectionHeading, {
    eyebrow: "WHOLEFOOD CHOCOLATE",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Chocolate that", /*#__PURE__*/React.createElement("br", null), "loves you back."),
    description: "Rich, velvety cacao buttons made from real whole foods \u2013 low in sugar, nothing artificial. The afternoon treat you can reach for without a second thought.",
    style: {
      marginBottom: 34
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 16
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onCta
  }, "Try Chaski Cacao"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 9,
      fontSize: 15,
      fontWeight: 300,
      color: "#6b5d4f"
    }
  }, /*#__PURE__*/React.createElement(Tick, null), /*#__PURE__*/React.createElement("span", null, "30-day money-back")))), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "1 1 50%",
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      overflow: "hidden",
      borderRadius: "var(--radius-image)",
      boxShadow: "var(--shadow-image)"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/product/hero-buttons.png",
    alt: "Chaski Cacao chocolate buttons",
    style: {
      display: "block",
      width: "100%",
      height: "auto"
    }
  })))));
}
function SugarSection() {
  return /*#__PURE__*/React.createElement(Section, {
    tone: "sand",
    "data-screen-label": "Sugar comparison"
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      display: "flex",
      flexDirection: "row-reverse",
      alignItems: "center",
      gap: "var(--col-gap-wide)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "1 1 52%",
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(SectionHeading, {
    eyebrow: "SWEETENED RIGHT",
    ground: "sand",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Just a fraction", /*#__PURE__*/React.createElement("br", null), "of the sugar"),
    description: "We sweeten with just a touch of raw coconut sugar \u2013 so Chaski has a fraction of the sugar of a typical chocolate bar, at a lower glycaemic index.",
    style: {
      marginBottom: 30
    }
  }), /*#__PURE__*/React.createElement(Callout, null, /*#__PURE__*/React.createElement(Tick, {
    variant: "disc"
  }), "No refined sugar \u2013 ever")), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "1 1 48%",
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(Card, {
    tone: "sand",
    radius: "var(--radius-card-lg)"
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    tone: "sand",
    size: "sm",
    style: {
      marginBottom: 28
    }
  }, "SUGAR PER SERVING"), /*#__PURE__*/React.createElement(ComparisonBar, {
    label: "Chaski Cacao",
    value: "3.3g",
    percent: 25
  }), /*#__PURE__*/React.createElement(ComparisonBar, {
    label: "A typical chocolate bar",
    value: "43g+",
    percent: 100,
    tone: "typical"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      height: 1,
      margin: "8px 0 20px",
      background: "var(--sand-320)"
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: "var(--font-body)",
      fontSize: 14,
      lineHeight: 1.55,
      fontWeight: 300,
      color: "var(--ink-440)"
    }
  }, "Illustrative comparison vs a standard 100g milk chocolate bar.")))));
}
const REVIEWS = [{
  quote: '"Didn\u2019t expect much, but noticeable difference to my energy through the day."',
  name: "Polly C."
}, {
  quote: '"Tastes lovely and I feel a bit more clear-headed after having one. Very pleased."',
  name: "Susan S."
}, {
  quote: '"I\u2019m no longer buying dark chocolate because this tastes so good and I\u2019m loving the energy."',
  name: "Jonathan C."
}];
function ReviewsSection({
  onCta
}) {
  return /*#__PURE__*/React.createElement(Section, {
    tone: "linen",
    "data-screen-label": "Reviews"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(SectionHeading, {
    eyebrow: "LOVED BY 50,000+",
    ground: "linen",
    title: "What people say",
    align: "center",
    size: "lg",
    style: {
      marginBottom: 52
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "var(--grid-gap)",
      width: "100%"
    }
  }, REVIEWS.map(r => /*#__PURE__*/React.createElement(ReviewCard, {
    key: r.name,
    quote: r.quote,
    name: r.name
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      marginTop: 52
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    onClick: onCta
  }, "Try Chaski Cacao"))));
}
function CacaoSection() {
  return /*#__PURE__*/React.createElement(Section, {
    tone: "cocoa",
    "data-screen-label": "The base"
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      display: "flex",
      flexDirection: "row-reverse",
      alignItems: "flex-start",
      gap: "var(--col-gap-wide)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "1 1 48%",
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      overflow: "hidden",
      borderRadius: "var(--radius-image-lg)",
      boxShadow: "var(--shadow-image-inverse)"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/product/farmer-desktop.png",
    alt: "Farmer holding a tray of fresh cacao pods",
    style: {
      display: "block",
      width: "100%",
      height: "auto"
    }
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "1 1 52%",
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(SectionHeading, {
    eyebrow: "THE BASE",
    tone: "dark",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Why we start", /*#__PURE__*/React.createElement("br", null), "with real cacao"),
    description: "Real cacao, not cocoa powder \u2013 minimally processed, just as it's been enjoyed for centuries. Deep chocolate flavour with a naturally warming lift.",
    style: {
      marginBottom: 34
    }
  }), /*#__PURE__*/React.createElement(Card, {
    tone: "dark",
    radius: "var(--radius-card)",
    padding: "6px 30px"
  }, [{
    h: "Naturally rich in magnesium",
    c: "The quiet mineral behind calmer days and deeper rest."
  }, {
    h: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      style: {
        fontFamily: "var(--font-numeral)",
        fontSize: "1.06em"
      }
    }, "40x"), " more antioxidants than blueberries"),
    c: "One of the richest sources on the planet."
  }].map((b, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    style: {
      display: "flex",
      alignItems: "flex-start",
      gap: 18,
      padding: "24px 0",
      borderTop: i ? "1px solid var(--hairline-light)" : undefined
    }
  }, /*#__PURE__*/React.createElement(Tick, {
    variant: "tile"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: 2
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 5,
      fontFamily: "var(--font-display)",
      fontWeight: 400,
      fontSize: "var(--size-subhead-sm)",
      lineHeight: 1.2,
      letterSpacing: "var(--ls-subhead)",
      color: "var(--ink-on-dark-heading)"
    }
  }, b.h), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-body)",
      fontWeight: 300,
      fontSize: 15,
      lineHeight: 1.45,
      color: "var(--ink-on-dark-muted)"
    }
  }, b.c))))))));
}
const EXTRACTS = [{
  icon: "../../assets/icons/lions-mane.png",
  heading: "Lion's Mane",
  copy: "A mushroom traditionally treasured throughout East Asia for centuries."
}, {
  icon: "../../assets/icons/cordyceps.png",
  heading: "Cordyceps",
  copy: "A remarkable mushroom long used in traditional Himalayan practices."
}, {
  icon: "../../assets/icons/ginkgo.png",
  heading: "Ginkgo Biloba",
  copy: "An ancient botanical from one of the world's oldest tree species."
}];
function ExtractsSection() {
  return /*#__PURE__*/React.createElement(Section, {
    tone: "wheat",
    "data-screen-label": "Functional extracts"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(SectionHeading, {
    eyebrow: "A QUIET BOOST",
    ground: "linen",
    title: "Three functional extracts, gently added",
    description: "Three traditional extracts, each with a rich history, gently complement our dark chocolate recipe.",
    align: "center",
    size: "sm",
    style: {
      marginBottom: 52
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "var(--grid-gap)",
      width: "100%"
    }
  }, EXTRACTS.map(e => /*#__PURE__*/React.createElement(IconCard, _extends({
    key: e.heading
  }, e, {
    alt: e.heading
  }))))));
}
const FAQ = [{
  question: "Why cacao instead of a powder, pill or gummy?",
  answer: "Because food works better than supplements. Chaski is made with nutrient-dense cacao because the body is designed to absorb nutrients from real food, not isolated capsules or gummies. Cacao supports digestion, circulation, and absorption—helping functional mushrooms and botanicals actually get used by the body. It also turns daily use into a ritual you enjoy, not a supplement you endure—making consistency, and results, far more natural."
}, {
  question: /*#__PURE__*/React.createElement(React.Fragment, null, "Is Chaski ", /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-numeral)",
      fontSize: "1.08em"
    }
  }, "100%"), " natural?"),
  answer: "Yes. Chaski is made entirely from real, whole-food ingredients—nothing artificial, nothing synthetic. We avoid common additives like soy lecithins, emulsifiers, artificial flavors, preservatives, and fillers often used in chocolate and supplements."
}, {
  question: "Where is the chocolate from?",
  answer: "Our cacao comes from heritage cacao grown in Peru, one of the world's most respected cacao regions. Our criollo cacao is prized for its natural richness, low acidity, and complex flavor—making it ideal for both taste and functional nutrition."
}, {
  question: "Does it contain sugar?",
  answer: "We sweeten Chaski with coconut sugar because it's a less processed, whole food sweetener that retains trace minerals and has a gentler effect on blood sugar than refined sugars. Unlike white sugar or syrups, coconut sugar doesn't overpower cacao's natural flavour or cause sharp energy spikes, and it's just 3.3g of sugar per serving."
}, {
  question: "Are there any side effects?",
  answer: "Chaski is made with gentle, food-based ingredients and is well tolerated by most people when used as directed. Because it contains natural cacao, you may feel a mild lift in energy or alertness—without the jitters or crash associated with coffee. As with any functional food, individuals who are sensitive to botanicals or who are pregnant, nursing, or taking medication should consult a healthcare professional before use."
}, {
  question: "Will Chaski make me trip?",
  answer: "Never. Chaski contains functional mushrooms like Lion's Mane and Cordyceps, which are 100% legal and non-psychoactive. They're completely different from psychedelic mushrooms and do not produce any hallucinogenic effects. They are intended solely for health and wellness."
}, {
  question: "How much should I take?",
  answer: "We recommend 4 cacao buttons per day (about 20g). This is the ideal daily amount to experience calm focus and mental clarity. You can take them all at once or spread them throughout the day—whatever fits your routine best."
}];
function FaqSection({
  onCta
}) {
  return /*#__PURE__*/React.createElement(Section, {
    tone: "linen",
    "data-screen-label": "FAQ"
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      display: "flex",
      alignItems: "flex-start",
      gap: "var(--col-gap-wide)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "1 1 40%",
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(SectionHeading, {
    eyebrow: "GOOD TO KNOW",
    ground: "linen",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Frequently", /*#__PURE__*/React.createElement("br", null), "asked questions"),
    style: {
      marginBottom: 20
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "0 0 30px",
      fontFamily: "var(--font-body)",
      fontWeight: 300,
      fontSize: 17,
      lineHeight: 1.55,
      color: "var(--ink-660)"
    }
  }, "Still unsure about something? ", /*#__PURE__*/React.createElement("a", {
    href: "#",
    style: {
      color: "var(--text-link)"
    }
  }, "Get in touch")), /*#__PURE__*/React.createElement(Button, {
    onClick: onCta
  }, "Buy now")), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "1 1 60%",
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(Accordion, {
    items: FAQ,
    defaultOpen: 0
  }))));
}
Object.assign(window, {
  HeroSection,
  SugarSection,
  ReviewsSection,
  CacaoSection,
  ExtractsSection,
  FaqSection,
  REVIEWS,
  EXTRACTS,
  FAQ
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/MarketingSections.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/MobileProduct.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const DS = window.SemvetaDesignSystem_5f8165 || {};
const {
  BenefitCard,
  PurchaseCard,
  PurchaseOption,
  PriceBlock,
  Button,
  Tick,
  StarRating,
  Eyebrow
} = DS;
const BENEFITS = [{
  icon: "../../assets/icons/cacao.png",
  heading: /*#__PURE__*/React.createElement(React.Fragment, null, "Wholefoods", /*#__PURE__*/React.createElement("br", null), "only"),
  copy: "Real cacao and simple, recognisable ingredients."
}, {
  icon: "../../assets/icons/sugar.png",
  heading: "Low in sugar",
  copy: "Just a touch of coconut sugar – no refined sugar."
}, {
  icon: "../../assets/icons/vegan.png",
  heading: "Plant-based",
  copy: "Dairy-free and 100% vegan, every single button."
}, {
  icon: "../../assets/icons/allergens.png",
  heading: "No nasties",
  copy: "No fillers, no gums, no artificial anything."
}];

/* The mobile DOM the live site serves under 768px: a 2×2 benefit grid and the
   PurchaseCard buy box. Neither exists in the desktop tree. */
function MobileProduct({
  onAdd
}) {
  const [plan, setPlan] = React.useState("sub");
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: 390,
      background: "var(--cream-100)",
      fontFamily: "var(--font-body)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "22px 20px 0"
    }
  }, /*#__PURE__*/React.createElement(StarRating, {
    tone: "gold",
    label: "4.5/5 based on 456 reviews"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "48px 20px 40px"
    },
    "data-screen-label": "Mobile benefits"
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    size: "mobile",
    style: {
      marginBottom: 15
    }
  }, "SNACKING, REIMAGINED"), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: "0 0 14px",
      fontFamily: "var(--font-display)",
      fontWeight: 400,
      fontSize: "var(--size-display-mobile)",
      lineHeight: .98,
      letterSpacing: "-1.4px",
      color: "var(--ink-880)"
    }
  }, "A treat that treats", /*#__PURE__*/React.createElement("br", null), "you well"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "0 0 26px",
      fontFamily: "var(--font-body)",
      fontWeight: 300,
      fontSize: 15,
      lineHeight: 1.5,
      color: "var(--ink-660)"
    }
  }, "Every button is built from real, whole-food ingredients \u2013 so you get the deep chocolate hit you crave, and a little something good in return."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0,1fr))",
      gap: 14
    }
  }, BENEFITS.map((b, i) => /*#__PURE__*/React.createElement(BenefitCard, _extends({
    key: i
  }, b))))), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "0 20px 44px"
    },
    "data-screen-label": "Mobile purchase"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      height: 1,
      margin: "0 0 40px",
      background: "var(--sand-300)"
    }
  }), /*#__PURE__*/React.createElement(PurchaseCard, {
    image: "../../assets/product/chaski-starter.png",
    title: "Chaski Cacao",
    subtitle: /*#__PURE__*/React.createElement(React.Fragment, null, "600g tube", /*#__PURE__*/React.createElement("br", null), "30 day supply."),
    reviewCount: "426"
  }, /*#__PURE__*/React.createElement(PurchaseOption, {
    selected: plan === "once",
    onSelect: () => setPlan("once"),
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "One-time", /*#__PURE__*/React.createElement("br", null), "purchase"),
    subtitle: plan === "once" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tick, null), " 1x tube delivered once") : null,
    price: /*#__PURE__*/React.createElement(PriceBlock, {
      price: "\xA344.99"
    })
  }), /*#__PURE__*/React.createElement(PurchaseOption, {
    selected: plan === "sub",
    onSelect: () => setPlan("sub"),
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Subscribe", /*#__PURE__*/React.createElement("br", null), "& Save"),
    badge: /*#__PURE__*/React.createElement("span", {
      style: {
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "4px 11px",
        borderRadius: "var(--radius-badge)",
        background: "var(--forest-500)",
        color: "#fff",
        fontSize: 11
      }
    }, /*#__PURE__*/React.createElement("span", null, "SAVE"), /*#__PURE__*/React.createElement("strong", {
      style: {
        fontWeight: 400
      }
    }, "20%")),
    subtitle: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Tick, null), " 1 tube delivered monthly"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Tick, null), " Swap, skip or cancel any time")),
    price: /*#__PURE__*/React.createElement(PriceBlock, {
      price: "\xA335.99",
      was: "\xA344.99"
    })
  }, plan === "sub" ? /*#__PURE__*/React.createElement("select", {
    style: {
      width: "100%",
      marginTop: 15,
      padding: "12px 14px",
      boxSizing: "border-box",
      border: "1.5px solid var(--sand-400)",
      borderRadius: 11,
      background: "var(--cream-25)",
      color: "var(--ink-880)",
      fontFamily: "var(--font-body)",
      fontSize: 14,
      cursor: "pointer"
    }
  }, /*#__PURE__*/React.createElement("option", null, "30 day supply"), /*#__PURE__*/React.createElement("option", null, "90 day supply")) : null), /*#__PURE__*/React.createElement(Button, {
    size: "block",
    fullWidth: true,
    style: {
      marginTop: 20
    },
    onClick: () => onAdd(plan === "sub" ? {
      title: "30-day supply",
      cart: "£35.99"
    } : {
      title: "One time purchase",
      cart: "£44.99"
    })
  }, "Add to cart"))));
}
Object.assign(window, {
  MobileProduct,
  BENEFITS
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/MobileProduct.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/ProductTop.jsx
try { (() => {
const DS = window.SemvetaDesignSystem_5f8165 || {};
const {
  PlanCard,
  Badge,
  StarRating
} = DS;
const GALLERY = ["../../assets/product/thumbnail-compliant.png", "../../assets/product/gallery-1.png", "../../assets/product/gallery-2.png", "../../assets/product/gallery-3.png", "../../assets/product/gallery-4.png", "../../assets/product/gallery-5.png", "../../assets/product/gallery-6.png", "../../assets/product/tube-buttons.png"];
const TIERS = [{
  id: "monthly",
  banner: /*#__PURE__*/React.createElement(Badge, {
    tone: "taupe",
    variant: "banner"
  }, "Most Popular - Save 20%"),
  title: "30-day supply",
  was: "£44.99",
  price: "£35.99 per tube",
  details: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, "\u2713 Only \xA31.20 per day"), /*#__PURE__*/React.createElement("div", null, "\u2713 1x tube (30 days supply) delivered monthly"), /*#__PURE__*/React.createElement("div", null, "\u2713 Pause or cancel anytime")),
  cart: "£35.99"
}, {
  id: "quarterly",
  banner: /*#__PURE__*/React.createElement(Badge, {
    tone: "aubergine",
    variant: "banner"
  }, "Best Value! 90 Day Supply"),
  title: "90-day supply",
  was: "£134.97",
  price: "£32.99 per tube",
  details: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, "\u2713 Free Shipping"), /*#__PURE__*/React.createElement("div", null, "\u2713 3x tubes delivered every 3 months"), /*#__PURE__*/React.createElement("div", null, "\u2713 Pause or cancel anytime")),
  cart: "£98.97"
}, {
  id: "once",
  title: "One time purchase",
  price: "£44.99 per tube",
  details: /*#__PURE__*/React.createElement("div", null, "\u2713 1x tube delivered once"),
  cart: "£44.99"
}];
function ProductTop({
  onAdd
}) {
  const [active, setActive] = React.useState(0);
  const [tier, setTier] = React.useState("monthly");
  const selected = TIERS.find(t => t.id === tier);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: "var(--cream-100)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1170,
      margin: "0 auto",
      padding: "40px 48px 20px",
      display: "flex",
      gap: 48,
      alignItems: "flex-start"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "1 1 55%",
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      borderRadius: "var(--radius-image)",
      overflow: "hidden",
      background: "var(--cream-50)"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: GALLERY[active],
    alt: "Chaski Cacao",
    style: {
      display: "block",
      width: "100%",
      height: "auto"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 10,
      marginTop: 10,
      overflowX: "auto"
    }
  }, GALLERY.map((src, i) => /*#__PURE__*/React.createElement("button", {
    key: src,
    onClick: () => setActive(i),
    style: {
      flex: "0 0 20%",
      padding: 0,
      border: i === active ? "1.5px solid var(--forest-500)" : "1.5px solid transparent",
      borderRadius: 12,
      overflow: "hidden",
      background: "none",
      cursor: "pointer",
      lineHeight: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: "",
    style: {
      display: "block",
      width: "100%",
      height: "auto"
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "1 1 45%",
      minWidth: 0,
      paddingTop: 8
    }
  }, /*#__PURE__*/React.createElement("h1", {
    style: {
      margin: "0 0 12px",
      fontFamily: "var(--font-display)",
      fontWeight: 400,
      fontSize: 38,
      lineHeight: 1.02,
      letterSpacing: "-1.2px",
      color: "var(--ink-900)"
    }
  }, "Chaski Cacao"), /*#__PURE__*/React.createElement(StarRating, {
    tone: "gold",
    label: "4.5/5 based on 456 reviews",
    style: {
      marginBottom: 22
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 26,
      maxWidth: 490
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "0 0 18px",
      fontFamily: "var(--font-body)",
      fontWeight: 400,
      fontSize: 17,
      lineHeight: 1.5,
      color: "#000"
    }
  }, "\"I wasn't expecting such a big tube, but wow! These taste amazing and I feel genuine focus. It's such a guilt free way to snack.\""), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: "var(--font-body)",
      fontWeight: 300,
      fontSize: 17,
      lineHeight: 1.4,
      color: "#000"
    }
  }, "\u2013 Jeanette")), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "86%",
      maxWidth: 490
    }
  }, TIERS.map(t => /*#__PURE__*/React.createElement(PlanCard, {
    key: t.id,
    selected: tier === t.id,
    onSelect: () => setTier(t.id),
    banner: t.banner,
    title: t.title,
    was: t.was,
    price: t.price,
    details: t.details
  })), /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: e => {
      e.preventDefault();
      onAdd(selected);
    },
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 28,
      padding: "10px 16px",
      minHeight: 46,
      background: "var(--forest-500)",
      borderRadius: 6,
      fontFamily: "var(--font-body)",
      fontWeight: 400,
      fontSize: 14.5,
      textDecoration: "none",
      color: "#fff",
      transition: "var(--transition-action)"
    }
  }, "Pre-order With Free Shipping")))));
}
Object.assign(window, {
  ProductTop,
  GALLERY,
  TIERS
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/ProductTop.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/SiteFooter.jsx
try { (() => {
const DS = window.SemvetaDesignSystem_5f8165 || {};
const {
  Button,
  Icon
} = DS;
const PROMOS = [{
  title: "Blog",
  copy: "Join us as we delve into ancient history, lost knowledge and much more."
}, {
  title: "Our Mission",
  copy: "Find out what we wish to achieve with Semveta and join the spiritual movement."
}];
function FooterPromotions() {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: "var(--cream-100)",
      borderTop: "1px solid var(--sand-300)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1240,
      margin: "0 auto",
      padding: "60px 48px",
      display: "flex",
      gap: 48
    }
  }, PROMOS.map(p => /*#__PURE__*/React.createElement("div", {
    key: p.title,
    style: {
      flex: 1,
      maxWidth: 650
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      aspectRatio: "1.768",
      borderRadius: 4,
      background: "var(--sand-150)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "var(--font-body)",
      fontSize: 12,
      fontWeight: 300,
      color: "var(--ink-480)"
    }
  }, p.title, " image \u2014 not in the supplied save"), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: "22px 0 10px",
      fontFamily: "Poppins, var(--font-display)",
      fontWeight: 700,
      fontSize: 22,
      color: "var(--ink-880)"
    }
  }, p.title), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "0 0 20px",
      fontFamily: "Jost, var(--font-body)",
      fontWeight: 400,
      fontSize: 16,
      lineHeight: 1.5,
      color: "var(--ink-700)"
    }
  }, p.copy), /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    size: "md",
    style: {
      minHeight: 44,
      padding: "10px 22px",
      fontSize: 15
    }
  }, "Take me there")))));
}
const COL1 = ["Search", "Blog", "Shipping", "Returns & Refunds", "About us", "Subscription Portal", "Privacy Policy", "Guides"];
const COL2 = ["Home", "Store", "Help Centre"];
function SiteFooter() {
  const link = {
    color: "#fff",
    textDecoration: "none",
    fontFamily: "Jost, var(--font-body)",
    fontSize: 15,
    fontWeight: 400,
    lineHeight: 2
  };
  const title = {
    margin: "0 0 14px",
    color: "#fff",
    fontFamily: "Poppins, var(--font-display)",
    fontWeight: 700,
    fontSize: 15,
    letterSpacing: ".02em"
  };
  return /*#__PURE__*/React.createElement("footer", {
    style: {
      background: "var(--navy-900)",
      color: "#fff"
    },
    "data-screen-label": "Footer"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1240,
      margin: "0 auto",
      padding: "56px 48px 28px",
      display: "flex",
      gap: 40
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "29%"
    }
  }, /*#__PURE__*/React.createElement("ul", {
    style: {
      margin: 0,
      padding: 0,
      listStyle: "none"
    }
  }, COL1.map(l => /*#__PURE__*/React.createElement("li", {
    key: l
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    style: link
  }, l))))), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "20%"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: title
  }, "Main menu"), /*#__PURE__*/React.createElement("ul", {
    style: {
      margin: 0,
      padding: 0,
      listStyle: "none"
    }
  }, COL2.map(l => /*#__PURE__*/React.createElement("li", {
    key: l
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    style: link
  }, l))))), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "33%"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: title
  }, "Sign up and save"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "0 0 16px",
      fontFamily: "Jost, var(--font-body)",
      fontSize: 15,
      fontWeight: 400,
      lineHeight: 1.5
    }
  }, "Subscribe to get special offers, free giveaways, and once-in-a-lifetime deals."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 8
    }
  }, /*#__PURE__*/React.createElement("input", {
    placeholder: "Enter your email",
    style: {
      flex: 1,
      background: "#fff",
      color: "#000",
      border: "1px solid #ccc",
      borderRadius: 6,
      padding: 10,
      fontFamily: "Jost, var(--font-body)",
      fontSize: 15
    }
  }), /*#__PURE__*/React.createElement("button", {
    "aria-label": "Subscribe",
    style: {
      border: "1px solid #ccc",
      borderRadius: 6,
      background: "#fff",
      padding: "0 12px",
      cursor: "pointer"
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevronDownWide",
    size: 18,
    color: "#000",
    style: {
      transform: "rotate(-90deg)"
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1240,
      margin: "0 auto",
      padding: "18px 48px 46px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 20
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 12,
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      background: "#111",
      padding: "10px 12px",
      fontFamily: "Jost, var(--font-body)",
      fontSize: 14,
      color: "#fff"
    }
  }, "United Kingdom (GBP \xA3)")), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "Jost, var(--font-body)",
      fontSize: 14
    }
  }, "\xA9 2026 Semveta Ltd")));
}
Object.assign(window, {
  SiteFooter,
  FooterPromotions
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/SiteFooter.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/SiteHeader.jsx
try { (() => {
const DS = window.SemvetaDesignSystem_5f8165 || {};
const {
  Icon,
  BagIcon
} = DS;
function AnnouncementBar() {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "10px 20px",
      textAlign: "center",
      fontFamily: "Jost, var(--font-body)",
      fontSize: 14,
      letterSpacing: ".02em",
      color: "var(--ink-880)",
      background: "var(--cream-100)"
    }
  }, "Free Shipping on all UK orders over \xA350");
}
function SiteHeader({
  cartCount = 0,
  onOpenCart,
  onSearch
}) {
  const link = {
    fontFamily: "Jost, var(--font-body)",
    fontSize: 18,
    fontWeight: 400,
    color: "var(--ink-880)",
    textDecoration: "none"
  };
  return /*#__PURE__*/React.createElement("header", {
    style: {
      position: "sticky",
      top: 0,
      zIndex: 40,
      background: "var(--cream-100)"
    }
  }, /*#__PURE__*/React.createElement(AnnouncementBar, null), /*#__PURE__*/React.createElement("div", {
    style: {
      borderBottom: "1px solid #e8e8e1"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1240,
      margin: "0 auto",
      padding: "18px 48px",
      display: "flex",
      alignItems: "center",
      gap: 24
    }
  }, /*#__PURE__*/React.createElement("nav", {
    style: {
      flex: 1,
      display: "flex",
      gap: 30
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    style: link
  }, "Home"), /*#__PURE__*/React.createElement("a", {
    href: "#",
    style: {
      ...link,
      textDecoration: "underline",
      textUnderlineOffset: 5
    }
  }, "Store"), /*#__PURE__*/React.createElement("a", {
    href: "#",
    style: link
  }, "Help Centre")), /*#__PURE__*/React.createElement("a", {
    href: "#",
    style: {
      flex: "0 0 100px",
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/logo/semveta-logo-purple-100.png",
    alt: "Semveta",
    style: {
      width: 100,
      height: "auto",
      display: "block"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: 22
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    "aria-label": "Log in"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "user",
    size: 24,
    color: "var(--ink-880)"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: onSearch,
    "aria-label": "Search",
    style: {
      border: "none",
      background: "none",
      padding: 0,
      cursor: "pointer"
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "search",
    size: 24,
    color: "var(--ink-880)"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: onOpenCart,
    "aria-label": "Cart",
    style: {
      position: "relative",
      border: "none",
      background: "none",
      padding: 0,
      cursor: "pointer"
    }
  }, /*#__PURE__*/React.createElement(BagIcon, {
    size: 24,
    color: "var(--ink-880)"
  }), cartCount > 0 ? /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      top: -4,
      right: -6,
      minWidth: 17,
      height: 17,
      borderRadius: "50%",
      background: "var(--forest-500)",
      color: "#fff",
      fontFamily: "var(--font-body)",
      fontSize: 10,
      lineHeight: "17px",
      textAlign: "center"
    }
  }, cartCount) : null)))));
}
function CartDrawer({
  open,
  onClose,
  items = [],
  subtotal = "£0.00"
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: onClose,
    style: {
      position: "fixed",
      inset: 0,
      background: "#000",
      opacity: open ? .4 : 0,
      pointerEvents: open ? "auto" : "none",
      transition: "opacity .25s ease",
      zIndex: 60
    }
  }), /*#__PURE__*/React.createElement("aside", {
    style: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      width: 400,
      maxWidth: "90vw",
      background: "#fff",
      zIndex: 61,
      transform: open ? "translateX(0)" : "translateX(100%)",
      transition: "transform .249s ease",
      display: "flex",
      flexDirection: "column",
      fontFamily: "var(--font-body)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "20px 24px",
      borderBottom: "1px solid rgba(0,0,0,.1)"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "Poppins, var(--font-body)",
      fontWeight: 700,
      fontSize: 18,
      color: "var(--ink-880)"
    }
  }, "Your cart"), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    "aria-label": "Close",
    style: {
      border: "none",
      background: "none",
      cursor: "pointer",
      padding: 0
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    size: 20,
    color: "var(--ink-880)"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      overflowY: "auto",
      padding: 24
    }
  }, items.length === 0 ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontWeight: 300,
      color: "var(--ink-600)"
    }
  }, "Your cart is currently empty.") : items.map((it, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    style: {
      display: "flex",
      gap: 16,
      alignItems: "flex-start",
      paddingBottom: 20
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: it.image,
    alt: "",
    style: {
      width: 88,
      height: 88,
      objectFit: "cover",
      borderRadius: 8,
      background: "var(--sand-150)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 400,
      fontSize: 15,
      color: "var(--ink-880)"
    }
  }, it.title), /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 300,
      fontSize: 13,
      color: "var(--ink-600)",
      marginTop: 3
    }
  }, it.plan), /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 400,
      fontSize: 15,
      color: "var(--ink-880)",
      marginTop: 8
    }
  }, it.price))))), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 23,
      background: "#f6f6f7",
      borderTop: "1px solid rgba(0,0,0,.1)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      padding: "0 0 20px",
      fontSize: 20,
      color: "rgba(0,0,0,.8)"
    }
  }, /*#__PURE__*/React.createElement("span", null, "Subtotal"), /*#__PURE__*/React.createElement("span", null, subtotal)), /*#__PURE__*/React.createElement("button", {
    style: {
      width: "100%",
      padding: 16,
      border: 0,
      borderRadius: 0,
      background: "#000",
      color: "#fff",
      fontFamily: "var(--font-body)",
      fontSize: 15,
      cursor: "pointer"
    }
  }, "Check out"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "12px 0 0",
      textAlign: "center",
      fontSize: 12,
      fontWeight: 300,
      color: "var(--ink-600)"
    }
  }, "Shipping, taxes, and discount codes calculated at checkout."))));
}
Object.assign(window, {
  AnnouncementBar,
  SiteHeader,
  CartDrawer
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/SiteHeader.jsx", error: String((e && e.message) || e) }); }

__ds_ns.PlanCard = __ds_scope.PlanCard;

__ds_ns.PriceBlock = __ds_scope.PriceBlock;

__ds_ns.PurchaseCard = __ds_scope.PurchaseCard;

__ds_ns.PurchaseOption = __ds_scope.PurchaseOption;

__ds_ns.AccordionItem = __ds_scope.AccordionItem;

__ds_ns.Accordion = __ds_scope.Accordion;

__ds_ns.BenefitCard = __ds_scope.BenefitCard;

__ds_ns.Callout = __ds_scope.Callout;

__ds_ns.Card = __ds_scope.Card;

__ds_ns.ComparisonBar = __ds_scope.ComparisonBar;

__ds_ns.IconCard = __ds_scope.IconCard;

__ds_ns.ReviewCard = __ds_scope.ReviewCard;

__ds_ns.Badge = __ds_scope.Badge;

__ds_ns.Button = __ds_scope.Button;

__ds_ns.Eyebrow = __ds_scope.Eyebrow;

__ds_ns.SectionHeading = __ds_scope.SectionHeading;

__ds_ns.StarRating = __ds_scope.StarRating;

__ds_ns.Tick = __ds_scope.Tick;

__ds_ns.Icon = __ds_scope.Icon;

__ds_ns.BagIcon = __ds_scope.BagIcon;

__ds_ns.Container = __ds_scope.Container;

__ds_ns.Section = __ds_scope.Section;

})();